import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import { Container, Button, Icon, Image, Grid } from 'semantic-ui-react'
import { Helmet } from "react-helmet"
import moment from 'moment'

import game_model from 'models/game_model'
import game_play_model from 'models/game_play_model'

import GameArea from './GameHArea'

import { WORDS_DICT } from "cont/words.js";


const GameH = props => {

	const [game, setGame] = useState()
	const [gpid, setGpid] = useState()

	const word = WORDS_DICT[Math.floor(Math.random() * WORDS_DICT.length)]

	const gid = props.match?.params?.gid || props?.gid || moment().tz("Australia/Melbourne").format('YYMMDD')

	useEffect( async _ => {

		const game_data = await game_model.get_game(gid, (props.match?.params?.gid || props?.gid) ? 'set' : 'auto');

		const gpid = await game_play_model.add_record(gid, 
											{
												word: game_data?.word,
											}, 
											{
												timestamp: true,
												add_by: true,
											}
										)

		setGame(game_data)
		setGpid(gpid)

		console.log('game_data loaded ', game_data, gpid, gpid);

	}, [gid])

	return <Container>
			<Helmet>
				<title>WeWordle Game</title>
			</Helmet>

			{/*<pre>
			{JSON.stringify(app.user, null, 4)}
			</pre>*/}

			{game?.word && gpid && 
				<GameArea
					gid = {gid}

					{...game}

					// onStart = { w => game_play_model.add_record(gid, 
					// 						{
					// 							guess: w,
					// 						}, 
					// 						{
					// 							timestamp: true,
					// 							add_by: true,
					// 						}
					// 					) }

					onCheck = { w => game_play_model.add_record(`${gid}/${gpid}/g`, 
											{
												guess: w,
											}, 
											{
												timestamp: true,
												// add_by: true,
											}
										) }

					onWin = { w => game_play_model.add_record(`${gid}/${gpid}/w`, 
											{
												win: w,
											}, 
											{
												timestamp: true,
												// add_by: true,
											}
										) }
					// word = {word}
					// max_guesses = {6}
					// // word_length = {5}
					// dict = {true}
				 />
			}
		</Container>
}

export default GameH